module.exports = __webpack_public_path__ + "img/y- (14).469307d8.jpg";